import type { ItgConfig } from "@ceeferenderer/itg-renderer-sdk";
import { flowId, FlowId } from "../constants/flowId";

type PartialItgConfig = Partial<Omit<ItgConfig, "FEProcessName" | "FEProcessGuid">> &
  Required<Pick<ItgConfig, "FEProcessName" | "FEProcessGuid">>;

export type FlowConfig = {
  itgConfig: PartialItgConfig;
  queryParamAllowList?: string[];
  queryParams?: Record<string, string>;
  templateId?: string;
};

const flowConfigs: Record<FlowId, FlowConfig> = {
  DRF_Payment_Research_And_Refund: {
    itgConfig: {
      FEProcessGuid: "d787c894-d06f-4757-8256-041e10925850",
      FEProcessName: "DRF_Payment_Research_And_Refund",
    },
  },
  DRF_Report_Problem_Tenure_Issue: {
    itgConfig: {
      FEProcessGuid: "4e67517e-32aa-4c87-90fe-af173cae5b05",
      FEProcessName: "DRF_Report_Problem_Tenure_Issue",
    },
    queryParamAllowList: ["problemType"],
  },
  Help_and_Support_Not_Found: {
    itgConfig: {
      FEProcessGuid: "b186f454-bd6d-49be-8f0e-975338853a92",
      FEProcessName: "Help_and_Support_Not_Found",
    },
  },
};

export const flowConfig = flowConfigs[flowId];
